// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sunkern: PokeData = {
  "id": 191,
  "name": "sunkern",
  "height": 3,
  "weight": 18,
  "base_experience": 36,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "razor-leaf",
    "solar-beam",
    "giga-drain",
    "synthesis",
    "sunny-day",
    "ingrain",
    "endeavor",
    "grass-whistle",
    "natural-gift",
    "worry-seed",
    "seed-bomb"
  ],
  "moves": [
    "tackle",
    "razor-leaf",
    "solar-beam",
    "synthesis",
    "sunny-day",
    "flower-rush",
    "wood-hammer",
    "overgrowth",
    "power-whip",
    "leaf-tornado",
    "aromatherapy",
    "grassy-terrain",
    "energy-ball"
  ],
  "evolution_chain": {
    "id": 94,
    "item": null,
    "species": [
      {
        "name": "sunkern",
        "order": 221,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sunflora",
        "order": 222,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 191,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sun-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 30,
    "speed": 30,
    "ability_power": 30
  },
  "stat_changes": [],
  "catch_rate": 235,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
